<script setup>
import {defineProps} from "vue";

//==================================================================//
//========================= Props / Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
]);

//==================================================================//
//===================== Recebimentos Headers =======================//
//==================================================================//

let recebimentosHeaders = [
    { text: '',                       value: 'visualizar'},
    { text: 'Seq do Vinculo',         value: 'sequencia'},
    { text: 'Status',                 value: 'status'},
    { text: 'Nota Fiscal Emitida',    value: 'notaFiscalEmitida'},
    { text: 'Data Criação',           value: 'dataCriacao'},
    { text: 'Valor Vinculado',        value: 'valorRecebimento'},
    { text: '',                       value: 'espaco'},
]


</script>

<template>

    <div class="c-table__header">

        <div class="c-header__cell" v-for="recebimentoHeader in recebimentosHeaders"
            :key="recebimentoHeader.value"
        >

            <div class="c-cell c-cell__text">

                {{recebimentoHeader.text}}

            </div>
            
        </div>

    </div>

</template>

<style scoped>

.c-table__header{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
    color: rgba(0, 0, 0, 0.6);
    font-size: 0.75rem;
}

.c-header__cell{
    align-content: center;
    padding: 14px 16px;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    font-weight: 700;
    background-color: #230bc1;
    color: #ffffff;
}

</style>